import { useTheme } from '../context/ThemeContext';
import { Sun, Moon } from 'lucide-react';

export default function ThemeToggle() {
  const { theme, toggle } = useTheme();
  return (
    <button
      onClick={toggle}
      data-testid="theme-toggle"
      title={theme === 'dark' ? 'Cambiar a modo claro' : 'Cambiar a modo oscuro'}
      aria-label="Toggle theme"
      className="fixed bottom-5 right-5 z-50 w-12 h-12 rounded-full bg-slate-800 hover:bg-slate-700 text-amber-300 border border-slate-600 shadow-lg flex items-center justify-center transition-all hover:scale-105 theme-toggle-btn"
    >
      {theme === 'dark' ? <Sun className="w-5 h-5" /> : <Moon className="w-5 h-5" />}
    </button>
  );
}
